// React 17+ JSX transform: explicit import not required
import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import SignIn from './components/Auth/SignIn';
import SignUp from './components/Auth/SignUp';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppLayout } from './layouts/AppLayout';
import DashboardPage from './pages/dashboard';
import ListUserPage from './pages/list-user';
import ManageCompanyPage from './pages/manage-company';
import ManageMachinePage from './pages/manage-machine';
import OfficePage from './pages/office';
import OnlineMeetingPage from './pages/online-meeting';
import UserChatPage from './pages/user-chat';
import UserReservationPage from './pages/user-reservation';
import UserReservationConfirmPage from './pages/user-reservation-confirm';

function AuthGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [showSignUp, setShowSignUp] = useState(false);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">読み込み中...</div>
      </div>
    );
  }

  if (!user) {
    if (showSignUp) {
      return (
        <SignUp
          onSuccess={() => setShowSignUp(false)}
          onSwitchToSignIn={() => setShowSignUp(false)}
        />
      );
    }
    return <SignIn onSwitchToSignUp={() => setShowSignUp(true)} />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AuthGate>
          <Routes>
            <Route
              path="/dashboard"
              element={
                <AppLayout>
                  <DashboardPage />
                </AppLayout>
              }
            />
            <Route
              path="/manage-company"
              element={
                <AppLayout>
                  <ManageCompanyPage />
                </AppLayout>
              }
            />
            <Route
              path="/manage-machine"
              element={
                <AppLayout>
                  <ManageMachinePage />
                </AppLayout>
              }
            />
            <Route
              path="/list-user"
              element={
                <AppLayout>
                  <ListUserPage />
                </AppLayout>
              }
            />
            <Route
              path="/user-chat"
              element={
                // チャットページはユーザ専用ヘッダー/フッターを内包する独立レイアウト
                <UserChatPage />
              }
            />
            <Route
              path="/user/reservation"
              element={
                // 予約ページはユーザ専用ヘッダーを内包する独立レイアウト
                <UserReservationPage />
              }
            />
            <Route
              path="/user/reservation/confirm"
              element={
                // 予約確認ページ（同ヘッダデザイン）
                <UserReservationConfirmPage />
              }
            />
            <Route
              path="/online-meeting/:meetingId?"
              element={
                <AppLayout>
                  <OnlineMeetingPage />
                </AppLayout>
              }
            />
            <Route
              path="/office"
              element={
                <AppLayout>
                  <OfficePage />
                </AppLayout>
              }
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthGate>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
